
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-india-prelims-thank-you",
      function () {
        return require("private-next-pages/all-india-prelims-thank-you/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-india-prelims-thank-you"])
      });
    }
  